import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class PagesServiceDemo {
    pages = [
        {name: "Home", route: "/demo/", icon: "home"},
        {name: "Agentes", route: "/demo/agentes", icon: "redeem"},
        {name: "Exploración", route: "/demo/exploracion", icon: "redeem"},
        {name: "Análisis de ventas", route: "/demo/analisis-ventas", icon: "redeem"},
        {name: "Reportes", route: "/demo/reportes", icon: "redeem"},
    ];

    getPages() {
        return this.pages;
    }
}